import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch event status data
export const fetchEventStatusData = createAsyncThunk(
  'players/fetchEventStatusData',
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_CMS_API_ROOT}` + '/restricted/api/v1/services/request/all', {
        headers: {
          'X-TOKEN': token,
          'Content-Type': 'application/json',
        }
      });
      const data = response.data.data;

      // Extract unique status_work_fsp values and create options
      const uniqueStatuses = [...new Set(data.map(item => item.status_work_fsp))];
      const statusOptions = uniqueStatuses.map(status => ({
        value: status,
        label: status.charAt(0).toUpperCase() + status.slice(1),
      }));

      return { eventStatusData: data, statusOptions: [{ value: 'All', label: 'All' }, ...statusOptions] };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
